/* Come AnimatedNumber e fmtEur: raggruppamento forzato, se no le quattro cifre
   restano senza punto e l'odometro scrive "4800" dove la riga accanto scrive
   "12.500". `true` a runtime diventa 'always'. */
const defaultFormat = (n: number) =>
  new Intl.NumberFormat('it-IT', { maximumFractionDigits: 0, useGrouping: true }).format(Math.round(n));

/**
 * Numero "odometer": ogni cifra è una colonna 0-9 che ROLLA verticalmente verso
 * il valore target (transition CSS). Più tattile del count-up: si percepisce il
 * movimento del dato. I separatori (. ,) restano fissi.
 */
export function Odometer({ value, format = defaultFormat }: { value: number; format?: (n: number) => string }) {
  const str = format(value);
  return (
    <span className="odo" aria-label={str}>
      {str.split('').map((ch, i) =>
        /\d/.test(ch)
          ? <OdoDigit key={i} d={Number(ch)} />
          : <span key={i} className="odo-sep" aria-hidden="true">{ch}</span>,
      )}
    </span>
  );
}

function OdoDigit({ d }: { d: number }) {
  return (
    <span className="odo-col" aria-hidden="true">
      <span className="odo-roll" style={{ transform: `translateY(${-d * 10}%)` }}>
        {Array.from({ length: 10 }, (_, n) => <span key={n} className="odo-n">{n}</span>)}
      </span>
    </span>
  );
}
